import React from "react";
import { aboutContent } from "../data/about";

export default function About() {
  return (
    <main className="min-h-screen pt-24">
      <div className="page-container">
        <h1 className="text-4xl sm:text-5xl font-semibold text-foreground tracking-tight mb-4">
          About Me
        </h1>
        <p className="text-muted text-lg mb-12 max-w-2xl">
          A deeper look into who I am, what I do, and what drives me.
        </p>

        <div className="space-y-8">
          {aboutContent.map((content, index) => (
            <AboutBlock
              key={index}
              icon={content.icon}
              header={content.header}
              description={content.description}
            />
          ))}
        </div>
      </div>
    </main>
  );
}

function AboutBlock({ icon: Icon, header, description }) {
  return (
    <div className="card flex flex-col sm:flex-row gap-6">
      <div className="flex-shrink-0">
        <div className="w-12 h-12 rounded-lg bg-border/50 flex items-center justify-center">
          <Icon size={24} className="text-foreground" />
        </div>
      </div>
      <div className="space-y-2">
        <h2 className="text-xl font-medium text-foreground">{header}</h2>
        <p className="text-muted leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
